export const ar = {
    'home': 'الرئيسية',
    'users': 'المستخدمون',
    'stores': 'المزودين',
    'bookings': 'الحجوزات',
    'finance': 'المالية',
    'banners': 'اللافتات',
    'featured': 'الاقسام',
    'notifications': 'الإشعارات',
    'settings': 'الإعدادات',
    'logout': 'تسجيل الخروج',
    'income': 'الدخل',

    'no': 'رقم',
    'store name': 'اسم المزود',
    'phone': 'الهاتف',
    'email': 'البريد الإلكتروني',
    'id store': 'معرف المتجر',
    'location': 'الموقع',
    'publishing': 'الخدمات',
    'status': 'الحالة',
    'action': 'الإجراء',
    'type': 'النوع',
    'id': 'المعرف',
    'image': 'الصورة',
    'name': 'الاسم',
    'search': 'بحث',
    'add store': 'إضافة متجر',
    'general': 'عام',
    'store information': 'معلومات المتجر',
    'service list': 'قائمة الخدمات',
    'store details': 'تفاصيل المتجر',



    'Store Name': 'اسم المزود',
    'Visiting Charge': 'رسوم الزيارة',
    'Address': 'العنوان',
    'City': 'المدينة',
    'At Home': 'في المنزل',
    'At Store': 'في المتجر',
    'About Company': 'عن الشركة',
    'Long Description': 'وصف طويل',
    'Commission': 'العمولة',
    'Sunday': 'الأحد',
    'Monday': 'الإثنين',
    'Tuesday': 'الثلاثاء',
    'Wednesday': 'الأربعاء',
    'Thursday': 'الخميس',
    'Friday': 'الجمعة',
    'Saturday': 'السبت',
    'Bank Name': 'اسم البنك',
    'Account Number': 'رقم الحساب',
    'Account Name': 'اسم الحساب',

    'Logo': 'الشعار',
    'Banner': 'لافتة',
    'Company Details': 'تفاصيل الشركة',
    'Bank Details': 'تفاصيل البنك',
    'Personal Information': 'المعلومات الشخصية',
    'Edit Store': 'تعديل المتجر',
    'Active': 'نشط',
    'featured sections': 'الأقسام المميزة',

    'Visiting Charges': 'رسوم الزيارة',
    'About this store': 'عن هذا المزود',
    'Working Days': 'أيام العمل',
    'Images': 'الصور',
    'Photos': 'الصور',
    'Location Information': 'معلومات الموقع',
    'Current Location': 'الموقع الحالي',
    'CR Certification': 'شهادة السجل التجاري',
    'ID Card': 'بطاقة الهوية',
    "To": "إلى",
    "on": 'في',
    "off": 'إيقاف',
    "Map": "الخريطة",
    'Phone Number': 'رقم الهاتف',
    "save": "حفظ",
    'Create store': 'إنشاء متجر',

    'Your email': 'بريدك الإلكتروني',
    'Type your password': 'أدخل كلمة المرور',
    'Password': 'كلمة المرور',
    'Sign in': 'تسجيل الدخول',
    'Loading': 'جارٍ التحميل',
    'Created at': 'تاريخ الإنشاء',
    'Edit': 'تعديل',
    "Add": "إضافة",
    'Delete': 'حذف',
    'Edit user': 'تعديل المستخدم',
    'Add user': 'إضافة مستخدم',

    'Setting': 'الإعدادات',
    'Terms & Privacy Settings': 'إعدادات الشروط والخصوصية',
    'Company Settings': 'إعدادات الشركة',
    'Company Title': 'عنوان الشركة',
    'Support Name': 'اسم الدعم',
    'Support Email': 'البريد الإلكتروني للدعم',
    'Mobile': 'الهاتف المحمول',
    'Select Time Zone': 'اختر المنطقة الزمنية',
    'Max Serviceable Distance (in Kms)': 'أقصى مسافة للخدمة (بالكيلومترات)',
    'Country Code': 'رمز الدولة',
    'Primary Color': 'اللون الأساسي',
    'Secondary Color': 'اللون الثانوي',
    'Primary Shadow Color': 'لون الظل الأساسي',
    'OTP System': 'نظام OTP',
    'Booking auto cancel Duration': 'مدة الإلغاء التلقائي للحجز',
    'Login Image': 'صورة تسجيل الدخول',
    'Company Address': 'عنوان الشركة',
    'Company Short Description': 'وصف الشركة المختصر',
    'Copyright Details': 'تفاصيل حقوق النشر',
    'Support Hours': 'ساعات الدعم',

    'Customer Terms and Conditions': 'شروط وأحكام العملاء',
    'Customer privacy policy': 'سياسة خصوصية العملاء',
    'Store Terms and Conditions': 'شروط وأحكام المتاجر',
    'Store Privacy Policy': 'سياسة خصوصية المتاجر',

    'Notification': 'الإشعار',
    'Title': 'العنوان',
    'Description': 'الوصف',
    'Date': 'التاريخ',

    'Featured Section': 'القسم المميز',
    'Rank': 'الترتيب',
    'Add Featured Section': 'إضافة قسم مميز',
    'Section Types': 'أنواع الأقسام',
    'Add Featured': 'إضافة مميز',
    'Add Banner': 'إضافة لافتة',
    'Select': 'اختر',
    'Store': 'متجر',
    'User': 'مستخدم',
    'Edit Banner': 'تعديل اللافتة',

    'Order Id': 'رقم الطلب',
    'User name': 'اسم المستخدم',
    'Order amount': 'مبلغ الطلب',
    'Admin commision': 'عمولة الإدارة',
    'Store amount': 'مبلغ المتجر',
    'Transaction date': 'تاريخ المعاملة',
    'Is Paid to store': 'تم الدفع للمتجر',
    'Paid': 'مدفوع',
    'Mark as paid': 'وضع علامة مدفوع',

    'Booking Detail': 'تفاصيل الحجز',
    'Date of order': 'تاريخ الطلب',
    'Payment status': 'حالة الدفع',
    'Price': 'السعر',
    'Quantity': 'الكمية',
    'Customer Details': 'تفاصيل العميل',
    'Contact Number': 'رقم الاتصال',
    'Co %': 'نسبة العمولة',
    'Total': 'الإجمالي',
    'Store Info': 'معلومات المتجر',
    'Company Name': 'اسم الشركة',
    'User phone': 'هاتف المستخدم',
    'Paymnet status': 'حالة الدفع',
    'View': 'عرض',
    'Timing Details': 'تفاصيل التوقيت',
    'Are you sure you want to delete this store?': 'هل أنت متأكد أنك تريد حذف هذا المتجر؟',
    'Yes': 'نعم',
    'No': 'لا',
    'Cancel': 'إلغاء',
    'Service Name': 'اسم الخدمة',
    'ID Store': 'معرف المتجر',
    'Detail': 'التفاصيل',
    'View Service': 'عرض الخدمة',
    'Service Details': 'تفاصيل الخدمة',
    'Service Price': 'سعر الخدمة',
    'Basic Details': 'التفاصيل الأساسية',
    'Product Name': 'اسم المنتج',
    'Product Details': 'تفاصيل المنتج',
    'View Product': 'عرض المنتج',
    'store phone': 'هاتف المتجر',
    'Send Notification': 'إرسال إشعار',
    'Post': 'نشر',
    'top': 'أعلى',
    'Save': 'حفظ',
    'Top services': 'أفضل الخدمات',
    'Top products': 'أفضل المنتجات',
    'Top stores': 'أفضل المتاجر',
    "State": "الولاية",
    "Company Whatsapp": "واتساب الشركة",
    "Company X": "X الشركة",
    "Company Instagram": "إنستجرام الشركة",
    "Categories": "الفئات",
    "New category": "فئة جديدة",
    "Action": "الإجراء",
    "dashboard": "لوحة التحكم",
    "Store requests": "طلبات المتاجر",
    "Approve": "الموافقة",
    "Reject": "رفض",
    "Rejected reason": "سبب الرفض",
    "Enter rejected reason": "أدخل سبب الرفض",
    "Add Service": "إضافة خدمة",
    "Category Name": "اسم الفئة",
    "Total services": "إجمالي الخدمات",

    "Finance": "تمويل",
    "Most providers": "معظم مقدمي الخدمة",
    "Most services": "معظم الخدمات",
    "Total orders": "إجمالي الطلبات",
    "Most stores": "معظم المتاجر",
    "Most services": "معظم الخدمات",
    "Arabic Name": "الاسم العربي",
    "Edit Category": "تحرير الفئة",
    "Discount": "تخفيض",
    "Final price": "السعر النهائي",
    "Category": "فئة",
    "Service Images": "صور الخدمة",
    "Select Category": "حدد الفئة",
    "Submit": "يُقدِّم",
    "Service Duration (Minutes)": "مدة الخدمة (بالدقائق)",
    "Order status": "حالة الطلب",
    "Visiting charges": "رسوم الزيارة",
    "Balance requests": "طلبات الرصيد",
    "Amount": "كمية",
}
